export var columnQuotes = [
    {
        editable: false,
        field: "quote",
        headerName: "Cotización/Póliza",
        width: 250,
    },
    {
        editable: false,
        field: "name",
        headerName: "Nombre y Apellido",
        width: 250,
    },
    {
        editable: false,
        field: "product",
        headerName: "Producto",
        width: 350,
    },
    {
        editable: false,
        field: "storeChannel",
        headerName: "Sucursal, tienda o canal",
        width: 260,
    },
    {
        editable: false,
        field: "status",
        headerName: "Estado",
        width: 160,
    },
];
export var Breadcrum = [
    {
        name: "Producto",
        key: "seguro",
        ariaCurrent: "",
    },
    {
        name: "Plan",
        key: "plan",
        ariaCurrent: "",
    },
];
